var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccueil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 314.42667 314.42667",
    fill: "currentColor",
    height: 314.42667,
    width: 314.42667,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,314.42667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m 2337.75,1148.7 v 0 c -443.56,477.11 -718.79,768.26 -1115.14,1183.41 -13.08,17.58 -26.73,26.13 -40.37,26.13 -19.92,0 -40.39,-8.55 -53.46,-26.13 L 19.9023,1157.25 C 6.80469,1139.6 0,1121.99 0,1104.34 c 0,-17.64 6.80469,-35.25 19.9023,-43.77 27.2813,-35.29 67.086,-35.29 94.4067,0 L 1182.24,2181.95 2243.92,1042.92 c 6.82,-9.06 26.72,-17.64 47.2,-17.64 19.9,0 33.56,8.58 46.63,17.64 27.3,26.17 27.3,79.07 0,105.78 z m -369.07,52.9 c -40.94,0 -67.66,-26.71 -67.66,-70.48 V 150.73 h -483.38 v 397.469 c 0,35.262 -27.28,70.512 -60.82,70.512 h -349.17 c -40.38,0 -73.923,-35.25 -73.923,-70.512 V 150.73 H 456.633 v 945.1 c 0,43.77 -33.563,70.48 -67.121,70.48 -40.364,0 -67.09,-26.71 -67.09,-70.48 V 71.1211 C 322.422,35.832 349.148,0 389.512,0 h 618.138 c 33.56,0 60.29,35.832 60.29,71.1211 V 477.141 h 214.95 V 71.1211 C 1282.89,35.832 1317,0 1356.82,0 h 611.86 c 33.54,0 67.12,35.832 67.12,71.1211 V 1131.12 c 0,43.77 -33.58,70.48 -67.12,70.48 v 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccueil);
export default __webpack_public_path__ + "static/media/accueil.c20c8290d1f1760b10f5fc89196b36e0.svg";
export { ForwardRef as ReactComponent };